function IconContainer({ icon = "", tooltip = "", layout = "" }) {
	return (
		<div
			className={`main_comp_icon_desc ${layout}`}
			data-tooltip-id="tooltip_small_top"
			data-tooltip-offset={10}
			data-tooltip-content={tooltip}
		>
			<span className={`icon_16 default ${icon}`}></span>
		</div>
	);
}

export default IconContainer;
